"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var KaitoriBonusCampaignModal_1 = __importDefault(require("~/components/modal/KaitoriBonusCampaignModal"));
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClickBanner = function () {
            var modalElement = document.createElement('div');
            var jsonProps = _this.data.get('modal-props');
            _this.trackBannerClick(jsonProps);
            _this.trackBannerImp(jsonProps);
            if (jsonProps) {
                react_dom_1.default.render(react_1.default.createElement(KaitoriBonusCampaignModal_1.default, __assign({}, JSON.parse(jsonProps))), modalElement);
                _this.element.appendChild(modalElement);
            }
        };
        _this.trackBannerClick = function (jsonProps) {
            window.dataLayer = window.dataLayer || [];
            if (jsonProps && typeof window !== 'undefined' && window.dataLayer) {
                var props = JSON.parse(jsonProps);
                var bannerId = props.bannerId;
                window.dataLayer.push({
                    event: 'banner_click',
                    banner_id: bannerId
                });
            }
        };
        _this.trackBannerImp = function (jsonProps) {
            window.dataLayer = window.dataLayer || [];
            if (jsonProps && typeof window !== 'undefined' && window.dataLayer) {
                var props = JSON.parse(jsonProps);
                var bannerId = _this.data.get('id');
                var position = _this.data.get('position') || props.bannerId;
                if (bannerId === null || position === null) {
                    return;
                }
                window.dataLayer.push({ event: 'banner_imp', banner_id: bannerId, location: position });
            }
        };
        return _this;
    }
    return default_1;
}(stimulus_1.Controller));
exports.default = default_1;
